import { array, object, string, number, boolean } from 'yup';
import i18n from 'src/utils/i18n/i18n';

export default {
  validation: (props) => object().shape({
    jobId: number().required(),
    clientId: string().required(i18n.t('REQUIRED')).nullable(),
    findings: array().of(
      object().shape({
        id: number().nullable(),
        rootCause: string().nullable(),
        modified: boolean(),
        actions: array().of(
          object().shape({
            id: number().nullable(),
            modified: boolean(),
            status: string().nullable().test('validation-of-oneOf', null, function(value) {
              // eslint-disable-line func-names
              const { path, createError } = this;
                  if( (props.auth.isCapManager && !props.auth.isAdmin) && (value === 'review_pending' || value === 'evidence_review_pending'))
                    return createError({ path, message: "Status should be changed" });
                  return false;
              }),  
            description: string().when('status',{
              is: (value) => (!props.auth.isCapManager && props.auth.isAdmin) || (props.auth.isFactoryUser || props.auth.isVendorUser),
              then: string().required(i18n.t('REQUIRED')),
              otherwise: string()
            }).nullable(),
            dueDate: string().when('status',{
              is: (value) =>  (!props.auth.isCapManager && props.auth.isAdmin) || (props.auth.isFactoryUser || props.auth.isVendorUser),
              then: string().required(i18n.t('REQUIRED')),
              otherwise: string()
            }).nullable(),
            actualCompletionOfActionDate: string().when('status',{
              is: (value) =>  (!props.auth.isCapManager && props.auth.isAdmin) || (props.auth.isFactoryUser || props.auth.isVendorUser),
              then: string().required(i18n.t('REQUIRED')),
              otherwise: string()
            }).nullable(),
            responsiblePerson: string().when('status',{
              is: (value) =>  (!props.auth.isCapManager && props.auth.isAdmin) || (props.auth.isFactoryUser || props.auth.isVendorUser),
              then: string().required(i18n.t('REQUIRED')),
              otherwise: string()
            }).nullable(),
            attachmentIds: array().of(number()),
            comments: array().of(
              object().shape({
                id: number().nullable(),
                comment: string().nullable()
              })
            ),
            resources: array().when('status',{
                is: (value) =>  (!props.auth.isCapManager && props.auth.isAdmin) || (props.auth.isFactoryUser || props.auth.isVendorUser),
                then: array().of(object().shape({
                  id: number().nullable(),
                  resourceType: string(),
                  currencyId: number().required(i18n.t('REQUIRED')).nullable(),
                  costs: number().typeError(i18n.t('REQUIRED')).required(i18n.t('REQUIRED')).nullable(),
                  details: string().required(i18n.t('REQUIRED')).nullable(),
                  staffDayType: string().when('resourceType', {
                    is: (value) => value === 'investment',
                    then: string().nullable(),
                    otherwise: string()
                    .required(i18n.t('REQUIRED')).nullable(),
                  }),
                  staffDayValue: number().when('resourceType', {
                    is: (value) => value === 'investment',
                    then: number().nullable(),
                    otherwise: number()
                    .required(i18n.t('REQUIRED')).nullable(),
                  }),
                  numberOfStaff: number().when('resourceType', {
                    is: (value) => value === 'investment',
                    then: number().nullable(),
                    otherwise: number()
                    .required(i18n.t('REQUIRED')).nullable(),
                  }),
                  averageDayRate: number().nullable().when('resourceType', {
                    is: (value) => value === 'investment',
                    then: number(),
                    otherwise: number()
                    .required(i18n.t('REQUIRED')),
                  }),
                })).required(i18n.t('ONE_RESOURCE_REQUIRED')),
                otherwise: array(),
          })
        })
        ).required(i18n.t('ONE_ACTION_REQUIRED'))
      })
    )
  })

};
